import React from 'react';
import { useNavigate } from 'react-router-dom';
import { theme } from '../theme';

const Header = ({ onBackToLanding }) => {
  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate('/');
  };

  return (
    <header 
      className="w-full border-b flex items-center justify-between px-6 py-3"
      style={{ 
        backgroundColor: theme.colors.bg.secondary,
        borderColor: theme.colors.border.primary,
        minHeight: '60px'
      }}
    >
      {/* Logo and Brand */}
      <div className="flex items-center space-x-4">
        
        
        <div 
          className="w-8 h-8 rounded-md flex items-center justify-center cursor-pointer transition-transform hover:scale-105"
          style={{ backgroundColor: theme.colors.accent.blue }}
          onClick={handleLogoClick}
          onMouseEnter={(e) => {
            e.target.style.transform = 'scale(1.1)';
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = 'scale(1)';
          }}
        >
          <span 
            className="text-white font-bold text-lg"
            style={{ fontFamily: theme.typography.fontFamily.sans.join(', ') }}
          >
            CM
          </span>
        </div>
        <h1 
          className="text-xl font-semibold"
          style={{ 
            color: theme.colors.text.primary,
            fontFamily: theme.typography.fontFamily.sans.join(', ')
          }}
        >
          <span className='hidden sm:block' >CodeMate</span>
        </h1>
      </div>

      {/* Center - Language Info */}
      <div className="flex items-center space-x-2">
        <span 
          className="text-xl font-medium"
          style={{ color: theme.colors.text.secondary }}
        >
          Online Code Compiler
        </span>
      </div>

      {/* Right Side Actions */}
      <div className="flex items-center space-x-3">
        {/* <button
          className="px-3 py-1.5 text-sm rounded-md border transition-colors hover:bg-opacity-10"
          style={{
            color: theme.colors.text.secondary,
            borderColor: theme.colors.border.primary,
            fontFamily: theme.typography.fontFamily.sans.join(', '),
            transition: theme.transitions.base
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = theme.colors.bg.tertiary;
            e.target.style.color = theme.colors.text.primary;
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = 'transparent';
            e.target.style.color = theme.colors.text.secondary;
          }}
        >
          Settings
       </button> */}
        <button
          className="px-3 py-1.5 text-sm rounded-md transition-colors"
          style={{
            color: theme.colors.text.inverse,
            backgroundColor: theme.colors.accent.blue,
            fontFamily: theme.typography.fontFamily.sans.join(', '),
            transition: theme.transitions.base
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = '#0860ca';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = theme.colors.accent.blue;
          }}
        >
          Sign In
        </button>
      </div>
    </header>
  );
};

export default Header;
